// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3FnpM","rootSuccess":"CompleteLink_rootSuccess__1UR0-","rootFailure":"CompleteLink_rootFailure__L8bFk","isDisabled":"CompleteLink_isDisabled__152V6"};